module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.type === 'NO_TICKET_COMPENSATE') ? _c('div', {
    staticClass: "t"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "t-body"
  }, _vm._l((_vm.policyArray), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "t-tr t-tr-compensate"
    }, [_c('div', {
      staticClass: "t-td"
    }, [_vm._v(_vm._s(item.noTicketCompensateMatchStr))]), _vm._v(" "), _c('div', {
      staticClass: "t-td"
    }, [_vm._v(_vm._s(item.noTicketCompensateModeStr))])])
  }), 0)]) : _c('div', {
    staticClass: "t"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "t-body"
  }, _vm._l((_vm.policyList), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "t-tr t-tr-refund",
      class: {
        't-tr-active': item.active,
        't-tr-expired': item.expired
      }
    }, [_c('div', {
      staticClass: "t-td"
    }, [_c('span', {
      staticClass: "co-tag"
    }, [_vm._v(_vm._s(item.time))]), (item.active) ? _c('span', {
      staticClass: "t-td-activetag"
    }, [_vm._v("当前阶段")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "t-td"
    }, [_vm._v(_vm._s(item.mode))])])
  }), 0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "t-head"
  }, [_c('div', {
    staticClass: "t-tr t-tr-compensate"
  }, [_c('div', {
    staticClass: "t-th t-td"
  }, [_vm._v("告知无票时间")]), _vm._v(" "), _c('div', {
    staticClass: "t-th t-td"
  }, [_vm._v("赔付比例")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "t-head"
  }, [_c('div', {
    staticClass: "t-tr t-tr-refund"
  }, [_c('div', {
    staticClass: "t-th t-td"
  }, [_vm._v("申请退票时间")]), _vm._v(" "), _c('div', {
    staticClass: "t-th t-td"
  }, [_vm._v("退票手续费")])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-7181e042", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7181e042","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/RefundPolicyTable.vue
// module id = 2271
// module chunks = 47